import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import MutualFundsListPageUI from './MutualFundsListPageUI.js'

class MutualFundsListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      mfTransferList: null,
      mfTransactions: null,
      financialYear: '',
      financialYearList: [],
      mfTxnList: null
    }
  }

  render() {
    return (
      <MutualFundsListPageUI
        context={this.props.context}
        accountNumber={this.props.match.params.accountNumber}
        mfTransferList={this.state.mfTransferList}
        mfTransactions={this.state.mfTransactions}
        mfTxnList={this.state.mfTxnList}
        totals={this.state.totals}
        mfMonthlyTotals={this.state.mfMonthlyTotals}
        onRefreshClick={this.onRefreshClick}
        //
        financialYear={this.state.financialYear}
        financialYearList={this.state.financialYearList}
        onFinancialYearChange={this.onFinancialYearChange}
      />
    )
  }

  onFinancialYearChange = (option) => {
    let context = this.props.context
    this.setState({ financialYear: option.value })
    this.getMutualFunds(context, this.props.match.params.accountNumber, option.value)
  }

  componentDidMount() {
    let context = this.props.context
    this.getYears(context)
    this.getBankTxns(context, this.props.match.params.accountNumber)
    // temporary code; will be removed to avoid full table scan
    this.getMutualFundsTxns(context, this.props.match.params.accountNumber)
  }

  getYears(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/years`,
      cacheKey: CacheKeys.Years(),
      callback: this.getYearsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getYearsCallback = (response) => {
    let financialYearList = response.financialYearList.map((years) => {
      return { value: years, label: years }
    })
    this.setState(
      { errorList: response.errorList, financialYearList: financialYearList },
      () => {
        let currentFinancialYear = response.currentFinancialYear
        this.getMutualFunds(this.props.context, this.props.match.params.accountNumber, currentFinancialYear)
      }
    )
  }

  getBankTxns(context, accountNumber) {
    let cacheManager = new CacheManager({
      resource: `/api/su/nodalBankAccounts/${accountNumber}/bankTransactions/external`,
      cacheKey: CacheKeys.ExternalTxns(accountNumber),
      callback: this.getBankTxnsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getBankTxnsCallback = (response) => {
    this.setState({
      mfTransferList: response.mfTransferList,
      totals: response
    })
  }

  getMutualFundsTxns(context, accountNumber) {
    let cacheManager = new CacheManager({
      resource: `/api/su/nodalBankAccounts/${accountNumber}/bankTransactions/mutualFunds`,
      cacheKey: CacheKeys.MutualFundsTxns(accountNumber),
      callback: this.getMutualFundsTxnsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getMutualFundsTxnsCallback = (response) => {
    this.setState({
      mfTxnList: response.transactionList,
    })
  }

  getMutualFunds(context, accountNumber, financialYear) {
    let cacheManager = new CacheManager({
      resource: `/api/su/nodalBankAccounts/${accountNumber}/mutualFunds`,
      cacheKey: CacheKeys.MutualFunds(accountNumber, financialYear),
      callback: this.getMutualFundsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context, null, {
      financialYear: financialYear
    })
  }

  getMutualFundsCallback = (response) => {
    this.setState({
      mfTransactions: response.mfTransactions,
      mfMonthlyTotals: response,
      financialYear: response.financialYear
    })
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Years())
    CacheManager.removeObject(CacheKeys.MutualFundsTxns(this.props.match.params.accountNumber))
    CacheManager.removeObject(CacheKeys.ExternalTxns(this.props.match.params.accountNumber))
    CacheManager.removeObject(CacheKeys.MutualFunds(this.props.match.params.accountNumber, this.state.financialYear))
    this.setState({ totals: null, mfTransactions: null }, () => {
      this.getYears(context)
      this.getMutualFundsTxns(context, this.props.match.params.accountNumber)
      this.getBankTxns(context, this.props.match.params.accountNumber)
      this.getMutualFunds(context, this.props.match.params.accountNumber, this.state.financialYear)
    })
  }
}

export default withRouter(MutualFundsListPageSF)
